import React from "react";

// Reusable red ribbon banner with notched ends, used over section cards.
export const RibbonBanner = ({ children, color = "#8B0000", textColor = "#fff", className = "" }) => (
  <div className={`relative inline-flex items-center justify-center ${className}`}>
    <div
      className="px-12 py-3 font-impact uppercase text-2xl md:text-3xl tracking-wider"
      style={{
        background: color,
        color: textColor,
        clipPath:
          "polygon(0 0, 100% 0, 95% 50%, 100% 100%, 0 100%, 5% 50%)",
      }}
    >
      {children}
    </div>
  </div>
);

// Nigerian flag stripe (green / white / green) used to overlay food images.
export const PanAfricanRibbon = ({ className = "" }) => (
  <div
    className={`absolute pointer-events-none ${className}`}
    style={{
      background:
        "linear-gradient(90deg, #008751 0%, #008751 33.33%, #FFFFFF 33.33%, #FFFFFF 66.66%, #008751 66.66%, #008751 100%)",
    }}
  />
);
